<template>
    <teleport to="body">
        <div class="full-screen-modal"
             :style="{background: modal_background}">
            <div class="inner">
                <div class="preview">
                    <slot name="preview"/>
                </div>
                <div class="content">
                    <slot/>
                </div>
            </div>

            <a class="close" href="#" @click.prevent.stop="close()">
                <i class="cvico-times-circle"/>
            </a>

        </div>
    </teleport>
</template>

<script>
import utils from "@/mixins/utils";
export default {
    name: "FullscreenModal",
    mixins: [utils],

    emits: ['close'],

    props: {
        color: {
            type: String,
            default: '#000',
        }
    },

    computed:{
        modal_background(){
            return `white linear-gradient(${[
                        '180deg',
                        this.utils.colorBrightness(this.color, 250) + ' 0%',
                        this.utils.colorBrightness(this.color, 240) + ' 52%',
                        this.utils.colorBrightness(this.color, 210) + ' 100%',
                    ].join(', ')}) 0% 0% no-repeat`;
        }
    },

    methods: {
        close(){
            this.$emit('close');
        }
    },

    mounted() {
        jQuery('body').css({overflow: 'hidden'});
    },

    beforeUnmount() {
        jQuery('body').css({overflow: 'auto'});
    }

}
</script>

<style lang="scss" scoped>
.full-screen-modal{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999999;

    .inner{
        display: flex;
        margin: auto;
        height: 100%;
        padding: 2rem 2rem;
        position: relative;
    }

    .preview{
        flex: 0 0 75%;
        height: 100%;
        overflow: auto;
        font-size: 0;
        line-height: 0;
        box-shadow: rgba(black, 0.15) 5px 5px 15px, rgba(black, 0.1) 3px 3px 3px;
        border-radius: .3rem;

        > *{
            font-size: $font-size-base;
            line-height: $line-height-base;
        }
    }

    .content{
        flex: 0 0 25%;
        padding-left: 2rem;
        padding-top: 2rem;
        height: 100%;
        overflow: auto;
    }

    .close{
        position: absolute;
        right: 1rem;
        top: 1rem;
        font-size: 2rem;
    }
}
</style>
